const PRIVACY_POLICY_QUERY_KEY = 'privacy-policy';

export { PRIVACY_POLICY_QUERY_KEY };
